export class LanguageFlyout {
    constructor() {
        $('#msLangNav').on('click',function(){
            $('#msLangNav').addClass('active');
        });
        $('#msLangNav.active').on('click',function(){
            $('#msLangNav').removeClass('active');
        });
        $('#msLangNav').on('mouseleave',function(){
            $('#msLangNav').removeClass('active');
            return false;
        });

        if ($(".enableFeloginBox").length > 0) {
            var id = "#msQMyAccountNavWrapper";
            $(id).dequeue();
            $(id).addClass("menuHover").delay(10000).queue(function () {
                $(id).removeClass("menuHover");
            });
        }
    }
}